"use strict";

var _toConsumableArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("@emotion/react");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var react_2 = require("react");

var Content_1 = require("./Content");

var __1 = require("..");

var frontend_notification_1 = require("@ryerson/frontend.notification");

var polished_1 = require("polished");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var DropFileInput = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 5px;\n\tbackground-color: white;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-top: 8px;\n\tmargin-bottom: 5px;\n\tpadding: 24px;\n\n\t", "\n"])), function (props) {
  var bgColor = props.bgColor,
      borderColor = props.borderColor;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t\tborder: 1px dashed ", ";\n\t\t"])), bgColor, borderColor);
});
var Overlay = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tbackground: white;\n\topacity: 0.9;\n"])));
var UploadText = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\theight: 100%;\n"])));
var StyledInput = styled_1.default.input(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\topacity: 0;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tcursor: pointer;\n"])));

var FileInput = function FileInput(_ref) {
  var language = _ref.language,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Files" : _ref$title,
      _ref$minFiles = _ref.minFiles,
      minFiles = _ref$minFiles === void 0 ? 0 : _ref$minFiles,
      _ref$maxFiles = _ref.maxFiles,
      maxFiles = _ref$maxFiles === void 0 ? 20 : _ref$maxFiles,
      _ref$allowedTypes = _ref.allowedTypes,
      allowedTypes = _ref$allowedTypes === void 0 ? Object.values(__1.FileInputTypes).map(function (item) {
    return item;
  }) : _ref$allowedTypes,
      _ref$maxSize = _ref.maxSize,
      maxSize = _ref$maxSize === void 0 ? 104857600 : _ref$maxSize,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$submitted = _ref.submitted,
      submitted = _ref$submitted === void 0 ? false : _ref$submitted,
      background = _ref.background,
      _ref$showFiles = _ref.showFiles,
      showFiles = _ref$showFiles === void 0 ? true : _ref$showFiles,
      dataTestId = _ref.dataTestId;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      lightGray = _theme$colors$primary.lightGray,
      link = _theme$colors$primary.link,
      error = _theme$colors$primary.error,
      white = _theme$colors$primary.white,
      success = _theme$colors$primary.success,
      text = _theme$colors$primary.text;
  var content = Content_1.FileInputContent[language];
  var display = {
    minFiles: minFiles,
    maxFiles: maxFiles,
    allowedTypes: allowedTypes,
    maxSize: maxSize
  };

  var _ref3 = (0, react_2.useState)(0),
      _ref4 = _slicedToArray(_ref3, 2),
      dragCounter = _ref4[0],
      setDragCounter = _ref4[1];

  var _ref5 = (0, react_2.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      invalid = _ref6[0],
      setInvalid = _ref6[1];

  var _ref7 = (0, react_2.useState)(""),
      _ref8 = _slicedToArray(_ref7, 2),
      errorType = _ref8[0],
      setErrorType = _ref8[1];

  var _ref9 = (0, react_2.useState)([]),
      _ref10 = _slicedToArray(_ref9, 2),
      files = _ref10[0],
      setFiles = _ref10[1];

  var onDragEnter = function onDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter(dragCounter + 1);
  };

  var onDragLeave = function onDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter(dragCounter - 1);
  };

  var onError = function onError(type) {
    setErrorType(type);
    setInvalid(true);
  };

  var onSuccess = function onSuccess(newFiles) {
    var updatedFiles = [].concat(_toConsumableArray(files), _toConsumableArray(newFiles));
    onChange(updatedFiles);
    setFiles(updatedFiles);
    clearError();
  };

  var removeFile = function removeFile(fileIndex) {
    clearError();
    var newFiles = files.filter(function (file, index) {
      return index !== fileIndex;
    });
    onChange(newFiles);
    setFiles(newFiles);
  };

  var onFileDrop = function onFileDrop(e) {
    var newFiles = e.target.files;
    var validSize = true;
    var validType = true;
    Array.from(newFiles).forEach(function (file) {
      if (file.size > maxSize) {
        validSize = false;
      }

      if (!(allowedTypes === null || allowedTypes === void 0 ? void 0 : allowedTypes.includes(file.name.split(".").pop()))) {
        validType = false;
      }
    });

    if (newFiles) {
      if (!validSize) {
        onError(__1.FileInputErrors.SIZE);
      } else if (!validType) {
        onError(__1.FileInputErrors.FILETYPE);
      } else if (files.length + newFiles.length > maxFiles) {
        if (files.length < maxFiles) {
          var slicedItems = Array.from(newFiles).slice(0, maxFiles - files.length);
          onError(__1.FileInputErrors.PARTIALMAX);
          onChange([].concat(_toConsumableArray(files), _toConsumableArray(slicedItems)));
          setFiles([].concat(_toConsumableArray(files), _toConsumableArray(slicedItems)));
        } else {
          onError(__1.FileInputErrors.MAX);
        }
      } else {
        onSuccess(newFiles);
      }

      submitted && files.length === 0 && required && onError(__1.FileInputErrors.REQUIRED);
    }

    setDragCounter(0);
  };

  var clearError = function clearError() {
    setErrorType("");
    setInvalid(false);
  };

  (0, react_2.useEffect)(function () {
    if (submitted) {
      files.length === 0 && required ? onError(__1.FileInputErrors.REQUIRED) : files.length < minFiles ? onError(__1.FileInputErrors.MIN) : errorType !== __1.FileInputErrors.PARTIALMAX && clearError();
    }
  }, [submitted, files]);
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      children: [title && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        type: type,
        children: title
      }), required && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        css: {
          marginLeft: "5px"
        },
        color: error,
        children: "*"
      })]
    }), showFiles && files.length > 0 && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        css: {
          marginTop: "10px"
        },
        wrap: "wrap",
        children: files.map(function (file, index) {
          return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            css: {
              marginRight: "6px",
              marginBottom: "6px"
            },
            children: (0, jsx_runtime_1.jsxs)(frontend_notification_1.Badge, {
              type: type,
              size: "sm",
              color: success,
              children: [file.name, (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                color: type === "secondary" ? white : text,
                css: {
                  marginLeft: "10px"
                },
                icon: "close",
                size: "sm",
                circled: true,
                dataTestId: "show-uploaded-files",
                onClick: function onClick() {
                  return removeFile(index);
                }
              })]
            })
          }, index);
        })
      })
    }), files.length < maxFiles && (0, jsx_runtime_1.jsxs)(DropFileInput, {
      bgColor: background || white,
      borderColor: !invalid ? (0, polished_1.rgba)(lightGray, 0.8) : (0, polished_1.mix)(0.4, error, white),
      onDragEnter: onDragEnter,
      onDragLeave: onDragLeave,
      children: [dragCounter > 0 && (0, jsx_runtime_1.jsx)(Overlay, {}), (0, jsx_runtime_1.jsxs)(UploadText, {
        justifyContent: "center",
        alignItems: "center",
        children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          size: "sm",
          icon: "attachment",
          color: link
        }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
          css: {
            marginLeft: "5px"
          },
          children: [content.dropFile, " ", (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            color: link,
            children: content.clickSelect
          })]
        }), "\xA0"]
      }), (0, jsx_runtime_1.jsx)(StyledInput, {
        accept: ".".concat(allowedTypes.join(",.")),
        type: "file",
        value: "",
        onChange: onFileDrop,
        multiple: true,
        "data-testid": dataTestId ? "".concat(dataTestId, "-file-drop") : ""
      })]
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      css: {
        marginTop: "10px"
      },
      direction: "column",
      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        type: type,
        children: content.allowedTypes.replace("%allowedTypes%", allowedTypes.sort().join(", "))
      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        type: type,
        children: content.filesLeft.replace("%filesLeft%", (maxFiles - files.length).toString())
      })]
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
      direction: "column",
      children: invalid && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        color: type !== "tertiary" ? error : (0, polished_1.mix)(0.4, error, white),
        children: errorType === __1.FileInputErrors.PARTIALMAX ? content[errorType].replace("%maxFiles%", maxFiles.toString()) : errorType !== "invalidFileType" ? content[errorType].replace("%".concat(errorType, "%"), isNaN(display[errorType]) ? display[errorType] : display[errorType].toLocaleString("en-US")) : content[errorType]
      })
    })]
  });
};

FileInput.displayName = "FileInput";
exports.default = FileInput;